/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/**
 * @description It converts human readable string to a string separated by underscores
 * @param text
 * @param separator
 * @param {string} string humanize to String
 * @returns {string}
 */
const snakeCase = (string) => {
    return string.replace(/\d+/g, ' ')
      .split(/ |\B(?=[A-Z])/)
      .map((word) => word.toLowerCase())
      .join('_');
};

export default snakeCase;
